import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../shared/config/app-config';
import { remembertempComponent } from '../patientonboard/remembertemp/remembertemp.component';
import { FormSessionCanDeactivate, JwtService, UserService } from '../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loginasmode',
  templateUrl: './loginasmode.component.html',
  styleUrls: ['./loginasmode.component.css']
})
export class LoginasmodeComponent extends FormSessionCanDeactivate {
  backinvalid: boolean;
  maxdate: boolean;
  bobMaxDate: any = new Date();
  mindate: boolean;
  showinvaild1: boolean;
  setmask: any;
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  constructor(private DatePipe: DatePipe, private idle: Idle, private _cookieService: CookieService,
    private dialog: MatDialog, private Userservice: UserService, private modalService: BsModalService, private router: Router, private jwtService: JwtService, private translate: TranslateService) {
    super();
    this.translate.setDefaultLang(Userservice.defaultLang);
  }

  confirmationpopup: MatDialogRef<remembertempComponent>;
  remember: MatDialogRef<remembertempComponent>;
  currentUser: any;
  dateValidation: any = false;
  imageURL: string = environment.cloudeImageURL;
  userDetails: any;
  public patientdob: any = "";
  inValidDOB: boolean = false;
  public datenew = new Date("01/01/1800");
  showloader: boolean = false
  ngOnInit() {

    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = true;
        if (this.currentUser.item) {
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      });



    this.getRoleList();
  }

  allRoleList: object = {};
  getRoleList() {
    this.Userservice.RoleListByLoginUser(encodeURI(this.currentUser.item.email ? this.currentUser.item.userId : ''), this.currentUser.item.clientTeleCode + '-' + this.currentUser.item.phone)
      .subscribe(data => {

        this.allRoleList = data;
        if (data.data.length == 1) {
          if (data.data[0].majorGroupId == 20 && !data.data[0].verified) {
            this.backinvalid = true
            this.showloader = false;
            this.selecteditem = data.data[0]
            this.dateValidation = true;
          }
        }
      });
  }


  patientValidation() {
    if (this.patientdob && this.patientdob != "Invalid Date") {
      this.showloader = true
    } else {
      this.checkempty1(this.patientdob)
    }
    let convertedDate = this.changeStringFormat2(this.patientdob);



    this.Userservice.patientValidationWithDOB(convertedDate, this.selecteditem.patientId, this.selecteditem.mappingId)
      .subscribe(data => {

        if (data.status == 'failure') {
          this.inValidDOB = true;
          this.showloader = false;
        }
        else {
          this.selecteditem.verified = true;
          this.EnterCorrespondingUser(this.selecteditem);
        }

      });

  }

  changeStringFormat2(dateString) {
    var dStartDate
    var changedFormat = '';

    var date: any = new Date(dateString)
    if (date != '' && date != null && date != 'Invalid Date') {
      changedFormat = this.DatePipe.transform(dateString, 'yyyy-MM-dd');
    } else if (date == 'Invalid Date' && dateString != 'Invalid Date' && dateString != undefined) {
      if (this.currentUser.item.language == 'en_uk') {
        if (dateString) {
          var splitDate1 = dateString.split('/');
          var day1 = splitDate1[0];
          var month1 = splitDate1[1];
          var year1 = splitDate1[2];
          dStartDate = month1 + "/" + day1 + "/" + year1;
        }
      }
      if (dStartDate) {
        changedFormat = this.DatePipe.transform(dStartDate, 'yyyy-MM-dd');
      }
    }
    return changedFormat
  }


  backUserList() {
    this.patientdob = "";
    this.dateValidation = false;
    this.inValidDOB = false;

  }

  selecteditem: any;

  EnterCorrespondingUser(item) {
    this.selecteditem = item;
    this.showloader = true;
    //this.dateValidation = false; 
    /*if(item.userGroupId==19)
      { this.getUserDetails(item.patientAccountId);
      }else if(item.userGroupId==20)
      {this.getUserDetails(item.patientAccountId);
      }else{} */

    if (item.majorGroupId == 20 && !item.verified) {
      this.showloader = false;
      this.dateValidation = true;
    }
    else {
      if (item.userGroupId == 19 && item.majorGroupId != 20)
        this.Userservice.selectedWorkFlowID = item.patientStageWorkflowId;
      else if (item.majorGroupId == 20 && item.isBodypartavailable) {
        ////console.log("Selected Patient Id : "+this.selecteditem.patientId);
        window.localStorage['patientId'] = this.selecteditem.patientId
        window.localStorage['onBehalfName'] = this.selecteditem.firstName + ' ' + this.selecteditem.lastName
        this.Userservice.selectedWorkFlowID = item.patientStageWorkflowId;
      }
      else
        this.Userservice.selectedWorkFlowID = 0

      this.LoginSelectedUser();
    }
  }


  LoginSelectedUser() {
    this.Userservice.muliRoleEnter = true;

    const credentials = {
      'username': this.selecteditem.cname,
      'password': btoa(this.selecteditem.cid),
      'captcha': '',
      'mode': '',
      'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
      'forcelogin': 'true',
      'UseraccountId':this.selecteditem.userAccountId
    }
    this.Userservice
      .attemptAuth(credentials)
      .subscribe(
        data => {
          if (window.localStorage["onboradingCP"] == "true") {
            this.confirmationpopup = this.dialog.open(remembertempComponent, { hasBackdrop: false });
            this.confirmationpopup.componentInstance.username = this.selecteditem.cname;
            this.confirmationpopup.afterClosed().subscribe(result => {
              this.confirmationpopup.close(); if (result == 'remember') {
                this._cookieService.set('username', this.selecteditem.cname);
                this._cookieService.set('remember', 'true');
              }
            });
          }

          setTimeout(() => {
            this.showloader = false;
          }, 3000)
          /*  window.localStorage.removeItem('session');
           this.idle.setIdle(this.idletime);
       
         this.idle.setTimeout(this.setidletime); */
        },
        err => {
          /* this.errors = err;
          this.isSubmitting = false;   */
          /* this.errors.message.replace('Authentication Failed:','') */
        }
      );
  }



  selectedUserDetails: any;
  getUserDetails(userAccountId) {
    /* alert("Selected UseraccountID" + userAccountId +"^^^^^^^^^^" +this.currentUser.item.userAccountId); */
    this.Userservice.getDetailsBasedOnRoleList(userAccountId, this.currentUser.item.token)
      .subscribe(data => {
        this.selectedUserDetails = data;
        //window.localStorage['Puser']

        if (this.selecteditem.userGroupId == 19) {
          this.getUserInfo();
        } else {

          this.selectedUserDetails.status = false;
          this.Userservice.setAuth(this.selectedUserDetails);
        }

      });
  }


  /* window.localStorage['Puser'] = this.selecteditem.patientStageWorkflowId; */

  workFlowDetail: any;
  workflowJSONDetails: any = {};
  getUserInfo() {
    //debugger

    this.Userservice.postuserinfoid(1, this.selecteditem.loginAccountId)
      .subscribe(data => {
        this.workFlowDetail = data;

        for (var i = 0; i < this.workFlowDetail[0].patientStageWorkflow.length; i++) {
          /* ////console.log(this.selecteditem.patientStageWorkflowId +"^^^^^^^^^^^^"+ this.workFlowDetail[0].patientStageWorkflow[i].patSWFId); */
          if (this.selecteditem.patientStageWorkflowId == this.workFlowDetail[0].patientStageWorkflow[i].patSWFId) {
            this.workflowJSONDetails = this.workFlowDetail[0].patientStageWorkflow[i];
            break;
          }

        }
        this.selectedUserDetails.status = false;
        this.Userservice.setAsUser(this.workflowJSONDetails, this.selectedUserDetails);
      })
  }


  logout() {
    this.Userservice.logoutuser(this.currentUser.item.userAccountId)
    this.Userservice.purgeAuth();
    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      //window.localStorage.clear()
      this.router.navigateByUrl('/plogin/' + plogin);

    } else {
      //this.currentUser.status==false
      //window.localStorage.clear()
      this.router.navigateByUrl('/login');
    }
  }

  checkempty1(id) {
    let date
    if (id != 'Invalid Date')
      date = this.DatePipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.DatePipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
      this.patientdob = ''
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
      this.patientdob = ''
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
      this.patientdob = ''
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }
}
